module.exports = __webpack_public_path__ + "static/media/Transactions.5bcaf36c.png";